import { SearchOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { translate } from '../../languages'
import { RootState } from '../../stores'

type ColumnActionHeaderProps = {
  onSearch: () => void
}

export const ColumnActionHeader: React.FC<ColumnActionHeaderProps> = ({
  onSearch,
}) => {
  const { language } = useSelector((state: RootState) => state.language)

  const isDesktopScreen = useMediaQuery({ minWidth: '1300px' })

  return (
    <>
      <span>{translate('common.action', language)}</span>
      {isDesktopScreen && (
        <>
          <br></br>
          <Button
            type="primary"
            size="small"
            icon={<SearchOutlined />}
            onClick={onSearch}
          >
            {translate('common.search', language)}
          </Button>
        </>
      )}
    </>
  )
}
